import React from 'react';
import { Typography } from '@mui/material';
import CustomDialog from 'components/Dialog/Dialog';

interface ManualEntryConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    confirmButtonText: string;
    onClose: () => void;
    onConfirm: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

const ManualEntryConfirmationDialog: React.FC<ManualEntryConfirmationDialogProps> = ({
    open,
    title,
    message,
    confirmButtonText,
    onClose,
    onConfirm,
    disabled = false,
    isLoading = false,
}) => {
    return (
        <CustomDialog
            open={open}
            handleClose={onClose}
            handleSubmit={onConfirm}
            title={title}
            buttonTxt={confirmButtonText}
            cancelBtn={true}
            cancelBtnTxt="Cancel"
            disabled={disabled}
            isLoading={isLoading}
            sx={{
                '& .MuiPaper-root': {
                    maxWidth: '420px',
                },
            }}
        >
            <Typography sx={{ fontSize: '16px', color: '#1b3e61', lineHeight: 1.5 }}>
                {message}
            </Typography>
        </CustomDialog>
    );
};

export default ManualEntryConfirmationDialog;
